export default __webpack_public_path__ + "static/media/img_share_position.ba69cf86.png";